import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosApi from "../../utils/httpClient";

const name = "skills";
const initialState = {
  skills: [],
  loading: false,
  error: null,
};

export const fetchSkills = createAsyncThunk("skills/fetchSkills", async () => {
  const data = await axiosApi.get(`${process.env.REACT_APP_BASE_URL}skill`);
  return data.data;
});

const skillsSlice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchSkills.pending, (state) => {
      state.skills = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchSkills.fulfilled, (state, action) => {
      state.skills = action.payload.data;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(fetchSkills.rejected, (state, action) => {
      state.skills = [];
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export default skillsSlice.reducer;
